import { INotification } from '@phonepe/crm';

import { RouteId } from './Routes.types';

export enum IMessageType {
	ACTION = 'ACTION',
}
export enum IMessageActionType {
	BRICKBAT_SURVEY = 'BRICKBAT_SURVEY',
}

export interface IRedirectionData {
	data: Array<{
		key: string;
		value: string;
		isEncoded: boolean;
	}>;
	isEncoded: boolean;
}
export interface IActionType {
	type?: IMessageType;
	actionType?: IMessageActionType;
}
export interface IMessageData extends IActionType {
	id: string;
	icon?: string;
	title: string;
	subTitle: string;
	message: string;
	date: string;
	link?: string;
}
export interface INotificationState {
	read: Array<IMessageData>;
	unread: Array<IMessageData>;
	newNotifications: IMessageData[];
}

export type NotificationLink = {
	link: string;
	routeId: RouteId;
};

export interface INavParamsData {
	redirection_data: IRedirectionData;
}

export type NotificationsHandler = (
	parsedNotifications: INotificationState,
) => void;

export type { INotification };

export { Channel, CrmScope } from '@phonepe/crm';
